




















import { Component, Prop, Vue } from 'vue-property-decorator';
import { Title } from '@/pages/profile/components/info/compopnents/block/components/itemsblock';
import { IResult, ResultEnum } from './types';

@Component({
  components: {
    Title,
  },
})
export default class ClassName extends Vue {
  @Prop({ type: Object, default: null })
  readonly result!: IResult;

  @Prop({ type: Boolean, default: false })
  readonly isChecked!: boolean;

  get isOffset() {
    const { result } = this;
    if (!result) return false;
    return result.rate_type === ResultEnum.OFFSET_TYPE;
  }

  get offset() {
    const { isOffset, result } = this;
    return isOffset && result.rate === 'PASS'
      ? ResultEnum.OFFSET
      : ResultEnum.DISREGARD;
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/profile/components/info/compopnents/block/components/result/Result.vue